import { useQuery } from '@tanstack/react-query'
import { cpGetAvailableWarehouses } from '@/lib/api/controlPlaneClient'

export function useAvailableWarehouses(enabled: boolean) {
  const query = useQuery({
    queryKey: ['available-warehouses'],
    queryFn: cpGetAvailableWarehouses,
    enabled,
    staleTime: 5 * 60 * 1000,
  })

  return {
    warehouses: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  }
}
